import { gql } from '@apollo/client';

export const GET_SORTER_PLAN_DWS_DETAIL = gql`
  query GetSorterPlanDwsDetail($id: Long!) {
    getSorterPlanDwsDetail(id: $id) {
      id
      sorterId
      sorterName
      sorterType
      warehouseId
      sorterPlanName
      status
      version
      isDropBag
      isSpecified
      exceptionChuteCode
      chuteConfig
      dwsChuteConfigs {
        id
        chuteCode
        chuteType
        isOverspecification
        isNone
        sortingCodes
      }
    }
  }
`;

export interface DwsChuteConfig {
  id?: number;
  chuteCode?: string;
  chuteType: string;
  isOverspecification?: boolean;
  isNone: boolean;
  sortingCodes?: string;
}

export interface SorterPlanDwsDetail {
  id: number;
  sorterId?: number;
  sorterName?: string;
  sorterType?: number;
  warehouseId?: number;
  sorterPlanName?: string;
  status: number;
  version: number;
  isDropBag: boolean;
  isSpecified: boolean;
  exceptionChuteCode?: string;
  chuteConfig?: string;
  dwsChuteConfigs: DwsChuteConfig[];
}

export interface GetSorterPlanDwsDetailData {
  getSorterPlanDwsDetail: SorterPlanDwsDetail | null;
}

export interface GetSorterPlanDwsDetailVariables {
  id: number;
}
